<template>
  <component
    :is="url ? 'a' : 'button'"
    :id="id"
    class="roomie-button roomie-buttonlink"
    :class="setClasses"
    :aria-label="ariaLabel"
    v-bind="url ? { href: url, target: targetType, rel: 'noopener noreferrer' } : {}"
    :type="!url ? 'button' : undefined">
    <span
      v-if="iconPlacement === 'left'"
      class="roomie-icon">
      <slot name="icon" />
    </span>

    <span
      class="roomie-button__content"
      :class="setContentClasses">
      <slot />
    </span>

    <span
      v-if="iconPlacement === 'right'"
      class="roomie-icon">
      <slot name="icon" />
    </span>
  </component>
</template>

<script>
export { SIZE, VARIANT, ICON_PLACEMENT } from './utils'

export default {
  name: 'RoomieButtonLink',
  props: {
    ariaLabel: {
      type: String,
      default: ''
    },
    id: {
      type: String,
      default: 'roomie-button-link',
      required: true
    },
    tabindex: {
      type: Number,
      default: 0
    },
    size: {
      type: String,
      default: 'md',
      validator: (value) => ['sm', 'md', 'lg'].includes(value),
      required: false
    },
    variant: {
      type: String,
      default: 'filled',
      validator: (value) => ['filled', 'outlined', 'ghost', 'white', 'primary'].includes(value),
      required: false
    },
    iconPlacement: {
      type: String,
      default: '',
      validator: (value) => ['', 'left', 'right'].includes(value)
    },
    url: {
      type: String,
      required: false,
      default: ''
    },
    targetType: {
      type: String,
      required: false,
      default: '_blank'
    }
  },
  computed: {
    setClasses() {
      return {
        'roomie-button--sm' : this.size === 'sm',
        'roomie-button--md' : this.size === 'md',
        'roomie-button--lg' : this.size === 'lg',
        'roomie-button--filled' : this.variant === 'filled',
        'roomie-button--outlined' : this.variant === 'outlined',
        'roomie-button--ghost' : this.variant === 'ghost',
        'roomie-button--primary' : this.variant === 'primary',
        'roomie-button--white' : this.variant === 'white'
      }
    },
    setContentClasses() {
      return {
        'icon-placement-left': this.iconPlacement === 'left',
        'icon-placement-right': this.iconPlacement === 'right'
      }
    }
  }
}
</script>

<style src='./_index.scss' lang='scss'/>
